import { render, staticRenderFns } from "./ResultsMercapromo.vue?vue&type=template&id=6ae9a2f6"
import script from "./ResultsMercapromo.vue?vue&type=script&lang=js"
export * from "./ResultsMercapromo.vue?vue&type=script&lang=js"
import style0 from "./ResultsMercapromo.vue?vue&type=style&index=0&id=6ae9a2f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports